import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  Route,
  Switch,
  Redirect,
  useHistory,
  useLocation,
} from "react-router-dom";
import { AppContext } from "./contexts/appContext";
import Header from "./pages/header.js";
import Header_Setting from "./pages/header_settings.js";
import Header_Reports from "./pages/header_reports";
import ForgetPassword from "./pages/forget-password.js";
import ForgetPasswordByID from "./pages/forget-password-byid.js";
import ChangePassword from "./pages/changePassword.js";
import Login from "./pages/login";
import Work from "./pages/work";
import CreateWork from "./pages/create_work.js";
import DetailWork from "./pages/detail_work";
import Promotion from "./pages/promotion";
import Set_Price from "./pages/set_price";
import Product from "./pages/product";
import MailControl from "./pages/mail_control.js";
import Setting_Type from "./pages/setting_type";
import Setting_Create_Type from "./pages/setting_type_create";
import Setting_Edit_Type from "./pages/setting_type_edit";
import Setting_Template from "./pages/setting_template";
import Setting_Create_Template from "./pages/setting_template_create";
import Setting_Edit_Template from "./pages/setting_template_edit";
import Setting_User from "./pages/setting_user";
import Setting_Edit_User from "./pages/setting_user_edit";
import Setting_Create_User from "./pages/setting_user_create";
import Setting_Product from "./pages/setting_product";
import Setting_Group_Bu from "./pages/setting_group_bu";
import Setting_Group_Bu_Create from "./pages/setting_group_bu_create";
import Setting_Group_Bu_Edit from "./pages/setting_group_bu_edit";
import Report from "./pages/report";
import Report2 from "./pages/reporton1on";
import MinDayPage from "./pages/min_day.js";
import HeaderLinks from "./components/Header_Links/index";
import { authAPI } from "./services/AuthService";
import Swal from "sweetalert2";
import image from "./assets/images/bg.png";
import { Backdrop, CircularProgress } from "@mui/material";
import "./App.css";
import moment from "moment";

const App = () => {
  const { login, updateLogin, updateUser, user, socket, setNotifications } =
    useContext(AppContext);
  const token = localStorage.getItem("Token");
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    let id = document.getElementById("root");
    if (id) {
      if (login) {
        id.style.height = "97vh";
      } else {
        id.style.height = "100vh";
      }
      id.style.backgroundImage = "url(" + image + ")";
    }
    if (login) {
      authAPI
        .GetUser(token)
        .then((res) => {
          if (res.status == 200) {
            socket.emit("join", { room: res.message.username });
            if (location.pathname == "/login") {
              history?.push("/");
            }
            updateUser(res.message);
            setLoading(false);
          } else {
            localStorage.removeItem("Token");
            setLoading(false);
            Swal.fire({
              icon: "error",
              confirmButtonColor: "#f27474",
              html: `<span class="colorWhite">${res.message}</span>`,
              backdrop: "transparent",
              background: "rgba(0,0,0,.75)",
              customClass: {
                icon: "switch",
              },
              width: "28rem",
              timer: 3000,
            }).then(() => {
              updateLogin(false);
            });
          }
        })
        .catch((error) => {
          localStorage.removeItem("Token");
          setLoading(false);
          Swal.fire({
            icon: "error",
            confirmButtonColor: "#f27474",
            html: `<span class="colorWhite">${error.message}</span>`,
            backdrop: "transparent",
            background: "rgba(0,0,0,.75)",
            customClass: {
              icon: "switch",
            },
            width: "28rem",
            timer: 3000,
          }).then(() => {
            updateLogin(false);
          });
        });
    } else {
      setLoading(false);
    }
  }, [login]);

  useEffect(() => {
    if (user) {
      const checkDate = moment("2025-07-01T07:05:11.910Z").valueOf();
      const updateDate = moment(user.updatedAt).valueOf();
      if (checkDate > updateDate) {
        Swal.fire({
          icon: "question",
          confirmButtonColor: "#22c55e",
          cancelButtonColor: "#f27474",
          showCancelButton: true,
          text: "คุณต้องการเปลี่ยนรหัสผ่านหรือไม่",
          width: "28rem",
        }).then(({ isConfirmed }) => {
          if (isConfirmed) history?.push("/change-password");
        });
      }
    }
  }, [user]);

  const checkSettings = useMemo(() => {
    try {
      let location_check = location.pathname.indexOf("/settings");
      if (location_check != -1) return true;
      else return false;
    } catch (error) {
      return false;
    }
  }, [location]);

  const checkReports = useMemo(() => {
    try {
      let location_check = location.pathname.indexOf("/report");
      if (location_check != -1) return true;
      else return false;
    } catch (error) {
      return false;
    }
  }, [location]);

  useEffect(() => {
    if (user) {
      socket.emit("SendNotification", {
        _id: " ",
        notification_obj: {
          is_read: "",
          title: "",
          detail: "",
          sender: user.username,
          push_to: "",
        },
      });
      socket.on("SendNotification", ({ status, message }) => {
        if (status == 200) {
          let find = message.find((res) => res.username == user.username);
          if (find) {
            if (location.pathname == find.push_to) {
              find.is_read = true;
            }
            setNotifications((old) => [...old, find]);
          }
        }
      });
    }
    return () => {
      setNotifications([]);
    };
  }, [user]);

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress style={{ color: "#6ab23a" }} />
      </Backdrop>
      {login && (
        <Header
          brand="Merchandise Messenger"
          rightLinks={<HeaderLinks />}
          fixed
          color="rose"
          changeColorOnScroll={{
            height: 400,
            color: "white",
          }}
        />
      )}
      {login &&
        user &&
        (user.manage_user ||
          user.manage_type ||
          user.manage_template ||
          user.manage_product ||
          user.manage_group_bu) &&
        checkSettings && <Header_Setting />}
      {login && user && user.view_report && checkReports && <Header_Reports />}
      <div
        className={
          login && user
            ? checkSettings &&
              (user.manage_user ||
                user.manage_type ||
                user.manage_template ||
                user.manage_product ||
                user.manage_group_bu)
              ? "containerS"
              : "containerx"
            : "containerZ"
        }
      >
        <Switch>
          {!login && (
            <Route path="/login">
              <Login />
            </Route>
          )}
          {!login && (
            <Route path="/forget-password/:_id">
              <ForgetPasswordByID />
            </Route>
          )}
          {!login && (
            <Route path="/forget-password">
              <ForgetPassword />
            </Route>
          )}
          {login && user && (
            <Route path="/change-password">
              <ChangePassword />
            </Route>
          )}
          {login && user && (
            <Route path="/mail">
              <MailControl />
            </Route>
          )}
          {login && user && user.view_report && (
            <Route path="/report1">
              <Report />
            </Route>
          )}
          {login && user && user.view_report && (
            <Route path="/report2">
              <Report2 />
            </Route>
          )}
          {login && user && user.manage_type && (
            <Route path="/settings/type/edit/:_id">
              <Setting_Edit_Type />
            </Route>
          )}
          {login && user && user.manage_type && (
            <Route path="/settings/type/create">
              <Setting_Create_Type />
            </Route>
          )}
          {login && user && user.manage_type && (
            <Route path="/settings/type">
              <Setting_Type />
            </Route>
          )}
          {login && user && user.manage_template && (
            <Route path="/settings/template/edit/:_id">
              <Setting_Edit_Template />
            </Route>
          )}
          {login && user && user.manage_template && (
            <Route path="/settings/template/create">
              <Setting_Create_Template />
            </Route>
          )}
          {login && user && user.manage_template && (
            <Route path="/settings/template">
              <Setting_Template />
            </Route>
          )}
          {login && user && user.manage_user && (
            <Route path="/settings/user/create">
              <Setting_Create_User />
            </Route>
          )}
          {login && user && user.manage_user && (
            <Route path="/settings/user/edit/:_id">
              <Setting_Edit_User />
            </Route>
          )}
          {login && user && user.manage_user && (
            <Route path="/settings/user">
              <Setting_User />
            </Route>
          )}
          {login && user && user.manage_product && (
            <Route path="/settings/product">
              <Setting_Product />
            </Route>
          )}
          {login && user && user.manage_group_bu && (
            <Route path="/settings/group_bu/create">
              <Setting_Group_Bu_Create />
            </Route>
          )}
          {login && user && user.manage_group_bu && (
            <Route path="/settings/group_bu/edit/:_id">
              <Setting_Group_Bu_Edit />
            </Route>
          )}
          {login && user && user.manage_group_bu && (
            <Route path="/settings/group_bu">
              <Setting_Group_Bu />
            </Route>
          )}
          {login && user && user.add_work && (
            <Route path="/create-work">
              <CreateWork />
            </Route>
          )}
          {login && user && user.view_work && (
            <Route path="/detail-work/:_id">
              <DetailWork />
            </Route>
          )}
          {login && user && user.view_work && (
            <Route path="/work">
              <Work />
            </Route>
          )}
          {login && user && user.view_promotion && (
            <Route path="/promotion">
              <Promotion />
            </Route>
          )}
          {login && user && user.view_set_price && (
            <Route path="/set_price">
              <Set_Price />
            </Route>
          )}
          {login && user && user.view_min_day && (
            <Route path="/min_day">
              <MinDayPage setLoading={setLoading} />
            </Route>
          )}
          <Route path="/product">
            <Product />
          </Route>
          {login ? (
            <Route
              exact={true}
              path="/"
              component={
                user?.view_work
                  ? Work
                  : user?.view_promotion
                  ? Promotion
                  : !loading && !user && Product
              }
            />
          ) : (
            <Redirect to="/login" />
          )}
          {login ? (
            <Route
              exact={true}
              path="*"
              component={
                user?.view_work
                  ? Work
                  : user?.view_promotion
                  ? Promotion
                  : !loading && !user && Product
              }
            />
          ) : (
            <Redirect to="/login" />
          )}
        </Switch>
      </div>
    </>
  );
};

export default App;
